<template>
  <div>
    <a download>模板/导入</a>
    <div class="container">
      <el-row>
        <el-col :span="10">
          <el-button type="primary">
            <a href="../tpls/退换货模板.xls" download>退换货excel模板</a>
          </el-button>
          <el-button type="primary">
            <a href="../tpls/正常出库模板.xls" download>正常出库excel模板</a>
          </el-button>
        </el-col>
        <el-col :span="12">
          <el-tooltip class="item" effect="dark" content="仅支持单个文件上传" placement="top-start">
            <el-upload
              class="upload-css"
              :file-list="uploadFiles"
              ref="upload"
              :on-success="upLoadSuccess"
              :on-error="upLoadError"
              :action="uploadURL"
              :headers="headers"
              :auto-upload="false"
              :limit="1"
            >
              <el-button slot="trigger" size="small" type="primary" @click="qingshuju()">选取文件</el-button>
              <el-button
                style="margin-left: 10px;"
                size="small"
                type="success"
                @click="submitUpload()"
              >正常出库导入</el-button>
              <el-button
                style="margin-left: 10px;"
                size="small"
                type="success"
                @click="submitUpload2()"
              >退换货导入</el-button>
            </el-upload>
          </el-tooltip>
          <br />
          <el-row>
            <el-col :span="11">
              <el-alert
                title="上传成功条数："
                type="success"
                effect="dark"
                show-icon
                :closable="false"
              >{{cgong}}</el-alert>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-alert
                title="上传失败条数："
                type="error"
                effect="dark"
                show-icon
                :closable="false"
              >{{sbai}}</el-alert>
            </el-col>
          </el-row>
          <!-- 失败列表 -->
          <br />
          <h4>失败列表</h4>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="OutBillCode" label="出库单号"></el-table-column>
            <el-table-column prop="Msg" label="失败原因"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import store from "@/store";
export default {
  props: [],
  data() {
    return {
      tableData: null,
      cgong: null,
      sbai: null,
      headers: {
        Token: store.getters.token //从cookie里获取token，并赋值  Authorization ，而不是token
      },
      projectName: "",
      uploadURL: null,
      //uploadURL: "/project/upload?a=1",
      uploadFiles: [] //上传的文件列表
    };
  },
  methods: {
    // 清数据
    qingshuju() {
      this.cgong = null;
      this.sbai = null;
      this.tableData = null;
    },
    //文件上传 正常出库导入
    submitUpload() {
      this.uploadURL =
        process.env.VUE_APP_BASE_API + "/api/wmsimprot/out";
      setTimeout(() => {
        this.$refs.upload.submit();
      }, 300);
    },
    // 退换货导入
    submitUpload2() {
      this.uploadURL =
        process.env.VUE_APP_BASE_API + "/api/wmsimprot/bater";
      setTimeout(() => {
        this.$refs.upload.submit();
      }, 300);
    },
    //文件上传成功时的钩子
    upLoadSuccess(response, file, fileList) {
      if (response.status_code == 200) {
        this.uploadFiles = [];
        const datatext = JSON.parse(response.data);
        this.cgong = datatext.Success;
        this.sbai = datatext.Fail;
        this.tableData = datatext.FailResult;
        console.log(datatext);
        this.$message({
          message: "上传成功",
          type: "success"
        });
      } else {
        this.$message.error("上传失败，请检查模板是否规范");
      }
    },
    //文件上传失败时的钩子
    upLoadError(response, file, fileList) {
      console.log("项目添加失败");
    }
  }
};
</script>

<style scope>
input[type="file"] {
  display: none;
}

.el-upload-list {
  width: 200px;
}

.el-select {
  width: 135px;
}
</style>